import {Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Entity } from 'app/pages/product/product.model';
import { Client } from './client.model';
import { ClientService } from './client.service';
import { SystemService } from '../../services/system.service';
import { AttributeValue } from '../attributes/attributes.model';
import { ProductService } from '../../pages/product/product.service';
import {MatSelectionList} from '@angular/material/list';
import {AttributesComponent} from '../attributes/attributes.component';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {FuseConfirmDialogComponent} from '../../../@fuse/components/confirm-dialog/confirm-dialog.component';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'client-form',
    templateUrl: './client-form.component.html',
    styleUrls: ['./client-form.component.scss'],
    encapsulation: ViewEncapsulation.None,
})

class ClientFormComponent implements OnInit {

    confirmDialogRef: MatDialogRef<FuseConfirmDialogComponent>;
    public clientForm: FormGroup;
    public action: string;
    public client: Client;
    private confirmP: string;
    format: any = { add: 'Agregar', remove: 'Quitar', all: 'Todos',
        none: 'Niguno', direction: 'left-to-right', draggable: false, locale: undefined };

    @Input()
    public title: string;

    @Output('entityChanged')
    changed: EventEmitter<any> = new EventEmitter();
    attributes: AttributeValue[];

    @ViewChild('attributesComp')
    attributesComp: AttributesComponent;


    constructor(private _formBuilder: FormBuilder,
                private clientService: ClientService,
                private _matSnackBar: MatSnackBar,
                public _systemService: SystemService,
                public _projectService: ProductService,
                public translate: TranslateService,
                public _matDialog: MatDialog) {
        // this.client = new Client();
    }

    ngOnInit(): void {
        this.translate.use(this._systemService.visibility.language);
        // this.clientForm = this.createClientForm();
    }

    guardarClient(): void{
        const theClient: any = new Client(this.clientForm.getRawValue());
        theClient.attributes = this.attributes;

        this.clientService.saveClient(theClient).subscribe(
            resp => {
                // Show the success message
                this._matSnackBar.open('Cliente guardado', 'OK', {
                    verticalPosition: 'top',
                    duration        : 4000
                });
                this.getAttributes(resp);
                this.changed.emit(resp);
            }
        );

    }

    deleteClient(): void{

        this.clientService.checkProjectsForClient(this.client)
            .subscribe(response => {

                    this.confirmDialogRef = this._matDialog.open(FuseConfirmDialogComponent, {
                        disableClose: false
                    });

                    this.confirmDialogRef.componentInstance.confirmMessage = '¿Está seguro que quiere borrar el cliente "' + this.client.name + '"?';

                    this.confirmDialogRef.afterClosed()
                        .subscribe(result => {
                            if ( result )
                            {
                                this.clientService.deleteClient(this.client).subscribe(
                                    resp => {
                                        this._matSnackBar.open('Cliente borrado', 'OK', {
                                            verticalPosition: 'top',
                                            duration        : 4000
                                        });

                                        this.changed.emit(this.client.id);
                                    }
                                );
                            }
                            this.confirmDialogRef = null;
                        });

                    return;

            }, error => {
                this._matSnackBar.open(error.error +
                    '\nPara borrarlo busque por nombre de cliente en la lista de proyectos y cambie o quite a todos el mismo.', 'OK', {
                    verticalPosition: 'top',
                    duration        : 8000
                });
            });


    }

    selected(entity: Entity): void{
        if (!entity) {
            this.client = null;
        } else {
            if (entity.id > 0) {
                this.clientService.getClient(entity.id)
                    .subscribe(
                        resp => {
                            this.client = new Client(resp);
                            this.clientForm = this.createClientForm();
                            this.attributes = [];
                            this.getAttributes(entity);
                            this.ngOnInit();
                        }
                    );
            }else{
                this.client = new Client(entity);
                this.clientForm = this.createClientForm();
                this.attributes = [];
                this.ngOnInit();
            }
        }
    }

    private getAttributes(entity: Entity): void {
        this._projectService.getAttributes('Client', entity.id + '').subscribe(
            respAttributes => {
                // this.attributes = [];
                // respAttributes.forEach(value => {
                //     const attValue: AttributeValue = new AttributeValue(value);
                //     this.attributes.push(attValue);
                // });
                respAttributes.sort((a, b) => a.name.localeCompare(b.name));
                this.attributes = respAttributes;
                if (this.attributes) {
                    this.attributesComp.ngOnInit();
                }
                // this.ngOnInit();
            }
        );
    }

    createClientForm(): FormGroup{
        return this._formBuilder.group({
            id                  : [this.client.id],
            name                : [this.client.name],
            email               : [this.client.email],
            description         : [this.client.description],
            contact             : [this.client.contact],
            otherContacts       : [this.client.otherContacts],
            rut                 : [this.client.rut],
            address             : [this.client.address],
            phone               : [this.client.phone],
            fiscalName          : [this.client.fiscalName]
            // creationDate        : [this.client.creationDate],
        });
    }

}

export default ClientFormComponent;
